










 

 














const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReflectionGroupHeader_meeting",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReflectionGroupTitleEditor_meeting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReflectionGroupVoting_meeting"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "localStage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isComplete",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "localPhase",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phaseType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RetrospectiveMeeting",
  "abstractKey": null
};

(node ).hash = "79f775407f4a176d5dc0909787126a20";

export default node;
